import { Button, Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys, queryValues } from '~/routes/query-params';
import {
  RankingMethodologyDrawer,
  RankingMethodologyType,
} from '~/widgets/knowledge-graph-widget/components/ranking-methodology-drawer/RankingMethodologyDrawer';

import styles from './RankingMethodologySection.module.scss';
import * as S from './RankingMethodologySection.styles';

export const RankingMethodologySection = ({
  rankingType,
}: {
  rankingType: RankingMethodologyType;
}) => {
  const { t } = useTranslation(['widget']);
  const { setQueryParams } = useQueryParams();

  return (
    <>
      <RankingMethodologyDrawer />
      <S.RankingMethodologyWrapper>
        <S.LabelWrapper>
          <Icon
            iconName="InformationCircle"
            size={20}
            fillColor="var(--icon-soft)"
          />
          <S.StyledLabel>
            {t(
              'widget:assetOverview.knowledgeGraph.themeExposure.rankIsCalculated'
            )}
          </S.StyledLabel>
        </S.LabelWrapper>
        <Button
          className={styles.styledButton}
          variant="tertiary"
          label={t(
            'widget:assetOverview.knowledgeGraph.themeExposure.viewMethodology'
          )}
          onClick={() =>
            setQueryParams({
              [queryKeys.activeDrawer]: queryValues.rankingMethodologyDrawer,
              [queryKeys.mode]: rankingType,
            })
          }
        />
      </S.RankingMethodologyWrapper>
    </>
  );
};
